export const SuggestedInfoContainer = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  return <div className="absolute inset-0 !p-5 flex flex-col justify-between shadow-inset-ivory">{children}</div>
}
